import { siteConfig } from '@/lib/site'

export type DemoPlacement = 'header' | 'hero' | 'player' | 'sticky' | 'bridge'

/**
 * Demo CTA target. The slug rides along (as ?ref= or in the mail subject) so
 * a booking can be traced back to the page that produced it.
 */
export function demoHref(slug: string, company?: string): string {
  if (siteConfig.demoUrl) {
    try {
      const url = new URL(siteConfig.demoUrl)
      url.searchParams.set('ref', slug)
      return url.toString()
    } catch {
      // Misconfigured VITE_DEMO_URL: fall through to mailto rather than ship a dead CTA.
    }
  }
  const subject = company ? `VoxDiscover demo for ${company}` : 'VoxDiscover demo request'
  return `mailto:${siteConfig.contactEmail}?subject=${encodeURIComponent(`${subject} (${slug})`)}`
}

export function requestPageHref(): string {
  const subject = encodeURIComponent('A VoxDiscover page for our product')
  const body = encodeURIComponent('Company website:\nProduct:\n')
  return `mailto:${siteConfig.contactEmail}?subject=${subject}&body=${body}`
}
